module.exports = "https://web-assets.ifttt.com/packs/media/stencils/phone-call-53a28552.svg";